import { cn } from '../../lib/cn';

type Props = { score: number; size?: 'sm' | 'md' };

export function ConfidenceIndicator({ score, size = 'md' }: Props) {
  const pct = Math.round(score * 100);
  let color = 'text-slate-500 bg-slate-100';
  if (score >= 0.85) color = 'text-success-700 bg-success-50';
  else if (score >= 0.7) color = 'text-warning-700 bg-warning-50';
  else color = 'text-error-700 bg-error-50';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        color,
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
      )}
      aria-label={`Confidence ${pct} percent`}
    >
      {pct}%
    </span>
  );
}
